import {
  createFileRoute,
  FileRoutesByPath,
  RouteComponent,
} from "@tanstack/react-router";

export const createRoute = <TFilePath extends keyof FileRoutesByPath>(
  path: TFilePath,
  component: RouteComponent,
  title: string,
  description: string,
) => {
  return createFileRoute(path)({
    head: () => ({
      meta: [
        { title },
        { property: "og:title", content: title },
        {
          name: "twitter:title",
          content: title,
        },
        { name: "description", content: description },
        { property: "og:description", content: description },
        { name: "twitter:description", content: description },
      ],
    }),
    component,
  });
};
